import { useState } from 'react';
import DialogTitle from './DialogTitle';
import PropTypes from 'prop-types';
import {
  Modal,
  DialogContent,
  Divider,
  Paper,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { updateDigitalCollection } from 'src/api/payerApi';
import { Error } from 'src/components/Banners';

export default function DigitalCollectionTermsDialog({ handleClose, isOpen }) {
  const [error, setError] = useState(null);
  const [selectedOption, setSelectedOption] = useState('');

  const handleConfirmation = () => {
    const shouldAcceptDigital = selectedOption === 'yes';
    updateDigitalCollection(shouldAcceptDigital, onSendSuccess, onSaveError);
  };

  const onSendSuccess = (acceptedDate) => {
    if (acceptedDate === '') {
      handleClose(null, 'Declined', undefined);
    } else {
      handleClose(null, 'Accepted', acceptedDate);
    }
  };

  const onSaveError = () => {
    setError('Villa kom upp við að staðfesta. Vinsamlegast reyndu aftur.');
  };
  return (
    <Modal
      onClose={(event) => handleClose(event, 'backdropClick')}
      open={isOpen}
      sx={{ overflow: 'scroll' }}
      disableEscapeKeyDown
    >
      <Paper
        sx={{
          padding: '40px',
          maxWidth: '1000px',
          width: '100%',
          margin: '60px auto',
          minHeight: '40vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Grid>
          <DialogTitle
            fontSize="40px"
            fontWeight="bolder"
            id="customized-dialog-title"
            onClose={(event) => handleClose(event, 'backdropClick')}
          >
            Viltu hætta að fá bréfpóst?
          </DialogTitle>
        </Grid>
        <Divider />
        <DialogContent>
          <Grid mb="50px">
            <Typography variant="h4" sx={{ fontSize: '21px', fontWeight: '300' }}>
              Við getum sent þér innheimtubréf og áminningar frá Motus og Lögheimtunni með stafrænum hætti. Stafrænar
              áminningar geta m.a. verið tölvupóstur og SMS. Þannig færðu áminningu vegna skulda í innheimtu hjá Motus
              og Lögheimtunni fyrr en ella og getur brugðist hraðar við.
            </Typography>
          </Grid>
          <Grid mb="30px">
            <RadioGroup value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
              <FormControlLabel
                value="yes"
                control={<Radio />}
                label="Já takk, sendið mér innheimtubréf og áminningar með stafrænum hætti"
                sx={{ '& .MuiFormControlLabel-label': { fontSize: '16px', fontWeight: '600' } }}
              />
              <FormControlLabel
                value="no"
                control={<Radio />}
                label="Nei takk, sendið mér bréfpóst."
                sx={{ '& .MuiFormControlLabel-label': { fontSize: '16px', fontWeight: '600' } }}
              />
            </RadioGroup>
          </Grid>
          <Grid container justifyContent="flex-end">
            <Button
              variant="outlined"
              sx={{
                fontSize: '16px',
                textTransform: 'none',
                borderRadius: '6px',
                mr: '10px',
              }}
              onClick={(event) => handleClose(event, 'cancelClick')}
            >
              HÆTTA VIÐ
            </Button>
            <Button variant="contained" onClick={handleConfirmation} disabled={!selectedOption}>
              SAMÞYKKJA
            </Button>
          </Grid>
          {error && (
            <Grid xs={12}>
              <Error error={{ message: error }} />
            </Grid>
          )}
        </DialogContent>
      </Paper>
    </Modal>
  );
}

DigitalCollectionTermsDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
